/**
 * «Настройки» — мои уведомления, агенты, ресторан, данные (§2 ТЗ портала, P2).
 *
 * - `/settings` — мои уведомления: тихие часы (все) и подписки финансового
 *   агента (у кого есть вход в финансы);
 * - `/settings/agents` — приёмка накладных и режим «проводит сам» (владелец);
 * - `/settings/restaurant` — начало операционных суток и реквизиты (владелец);
 * - `/settings/data` — свежесть данных, выключатель сбора, расход на ИИ
 *   (владелец).
 *
 * Здесь только то, что уже работает в коде сервисов: каждая настройка
 * читается агентом, а меняется той же функцией, что у бота.
 */

import type { Navigation } from '../../api';
import { Link, useRoute } from '../../router';
import { Agents } from './Agents';
import { Data } from './Data';
import { Notifications } from './Notifications';
import './settings.css';

type Tab = 'mine' | 'agents' | 'restaurant' | 'data';

const TABS: { code: Tab; title: string; to: string; host: boolean }[] = [
  { code: 'mine', title: 'Мои уведомления', to: '/settings', host: false },
  { code: 'agents', title: 'Агенты', to: '/settings/agents', host: true },
  { code: 'restaurant', title: 'Ресторан', to: '/settings/restaurant', host: true },
  { code: 'data', title: 'Данные', to: '/settings/data', host: true },
];

function tabOf(path: string): Tab {
  const found = TABS.find((tab) => tab.code !== 'mine' && path.startsWith(tab.to));
  return found?.code ?? 'mine';
}

export default function Settings({ nav }: { nav: Navigation }) {
  const route = useRoute();
  const host = nav.user.is_host;
  const visible = TABS.filter((tab) => host || !tab.host);
  const wanted = tabOf(route.path);
  const tab = visible.some((item) => item.code === wanted) ? wanted : 'mine';

  return (
    <div className="page page--narrow set">
      <header className="page__head set__head">
        <p className="page__eyebrow">Система</p>
        <h1 className="page__title">Настройки</h1>
      </header>
      {visible.length > 1 && (
        <nav className="chips set__tabs" aria-label="Разделы настроек">
          {visible.map((item) => (
            <Link
              key={item.code}
              to={item.to}
              className={`chip${tab === item.code ? ' chip--active' : ''}`}
              aria-current={tab === item.code ? 'page' : undefined}
            >
              {item.title}
            </Link>
          ))}
        </nav>
      )}
      {tab === 'mine' && <Notifications nav={nav} />}
      {tab === 'agents' && <Agents group="receipts" />}
      {tab === 'restaurant' && <Agents group="restaurant" />}
      {tab === 'data' && <Data />}
    </div>
  );
}
